import Playground from 'modules/schedule/Layout/Playground'

const PlaygroundPage = () => {
	return <Playground />
}

export default PlaygroundPage
